window.lang2 = 
{
  "contact": {
    "form": {
      "name": "Adınız",
      "email": "E-posta adresiniz",
      "phone": "Telefonunuz",
      "message": "Yorumunuz",
      "send": "gönder",
      "submit_contact": "İletişim kur",
      "post_success": "Bizimle iletişime geçtiğiniz için teşekkür ederiz. En kısa zamanda size geri döneceğiz.",
      "placeholder_message": "Lütfen yorumunuzu buraya bırakın"
    }
  },
  "home_page": {
    "show_more": "Daha fazla göster",
    "sections": {
      "frontpage_title": "Frontpage Koleksiyonu",
      "featured_title": "Öne Çıkan Koleksiyonlar",
      "news_title": "Son Haberler"
    },
    "onboarding": {
      "modal_title": "Neredeyse...",
      "no_products_html": "Frontpage koleksiyonunuzda hiç ürün yok. Bu yer tutucu, <a href=\"\/admin\/collections?tutorial=Frontpage\"> bu koleksiyona ürün ekleyene kadar <\/a> görünecektir.",
      "add_product": "Ürün ekle",
      "product_title": "Örnek Ürün Başlığı",
      "no_collections_html": "Burada gösterilecek koleksiyonunuz yok. Varsayılan Frontpage ile birlikte gitmek için <a href=\"\/admin\/custom_collections\"> bazı koleksiyonlar ekleyin <\/a>.",
      "add_collection": "Koleksiyon ekle",
      "collection_title": "Örnek Koleksiyon Başlığı"
    },
    "no_more_product": "Daha fazla ürün yok"
  },
  "collections": {
    "general": {
      "title": "Koleksiyonları",
      "no_matches": "Üzgünüz, bu koleksiyonda ürün yok",
      "show_more": "Daha fazla göster",
      "no_more_product": "Daha fazla ürün yok",
      "link_title": "Bizim göz atın {{ title }} Toplamak",
      "grid_view": "Izgara görünümü",
      "title_all": "Ürünler",
      "list_view": "Liste görünümü",
      "shop_the_collection": "Mağaza Koleksiyonu",
      "items_count": {
        "one": "ürün",
        "other": "ürünler"
      },
      "items_with_count": {
        "one": "{{ count }} ürün",
        "other": "{{ count }} ürünler"
      }
    },
    "sidebar": {
      "types": "Ürün Çeşitleri",
      "vendors": "Satıcılar",
      "tags": "Etiketler",
      "clear": "Açık",
      "clear_all": "Hepsini temizle",
      "refined_by": "Tarafından rafine"
    },
    "sorting": {
      "title": "Göre sırala",
      "featured": "Öne çıkan",
      "best_selling": "En iyi satış",
      "az": "Alfabetik olarak A-Z",
      "za": "Alfabetik olarak Z-A",
      "price_ascending": "Fiyat, yüksekten düşüğe",
      "price_descending": "Fiyat pahalıdan ucuza",
      "date_descending": "Tarih, eskiden yeni",
      "date_ascending": "Tarih, eskiden yeniye"
    },
    "toolbar": {
      "view_as": "Olarak görüntüle",
      "show": "Göstermek",
      "showing": "gösterme",
      "all": "Herşey",
      "of": "arasında",
      "previous": "Önceki",
      "next": "Sonraki"
    }
  },
  "general": {
    "breadcrumbs": {
      "home": "Ana Sayfa",
      "cart": "Alışveriş kartı",
      "home_link_title": "Ön sayfaya geri dön"
    },
    "newsletter_form": {
      "submit": "Abone ol",
      "newsletter_text": "email adresinizi giriniz",
      "newsletter_email": "your-email@example.com"
    },
    "404": {
      "title": "404 Sayfa Bulunamadı",
      "subtext_html": "İstediğiniz sayfa mevcut değil.",
      "click_here": "Buraya TIKLAYIN",
      "continue_shopping": "alışverişe devam edin."
    },
    "search": {
      "title": "ürün arama",
      "placeholder": "arama",
      "submit": "Arama",
      "no_results_html": "\"{{terms}}\" için yaptığınız arama sonuç vermedi.",
      "results_for_html": "\"{{terms}}\" aramanızın sonuçları:"
    },
    "currency": {
      "change_text": "Mağazanın para birimi"
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Yayınlanan {{ date }} tarafından {{ author }}",
      "older_post": "Daha eski gönderi",
      "newer_post": "Yeni Yazı",
      "tags": "Etiketler",
      "comment_meta_html": "{{ author }} on {{ date }}",
      "read_more": "Daha fazla oku"
    },
    "comments": {
      "title": "yorum Yap",
      "name": "Adınız",
      "email": "E-posta adresiniz",
      "message": "Senin yorumun",
      "post": "Yorum Gönder",
      "moderated": "Lütfen, yorumların yayınlanmadan önce onaylanması gerektiğini unutmayın.",
      "success_moderated": "Yorumunuz başarıyla gönderildi. Blogumuz yönetildiği için kısa bir süre içinde yayınlayacağız.",
      "success": "Yorumunuz başarıyla gönderildi! Teşekkür ederim!",
      "note": "Tüm blog yorumları yayınlanmadan önce kontrol edilir",
      "comments_with_count": {
        "one": "{{ count }} yorum Yap",
        "other": "{{ count }} yorumlar"
      }
    },
    "sidebar": {
      "recent_articles": "son Makaleler",
      "categories": "Kategoriler"
    }
  },
  "cart": {
    "general": {
      "title": "Sepetİm",
      "remove": "Kaldır",
      "note": "Satıcı için özel talimatlar",
      "subtotal": "Ara toplam",
      "shipping_at_checkout": "Kargo ve vergi ödeme sırasında hesaplanan vergiler",
      "update": "Sepeti Güncelle",
      "checkout": "Çıkış",
      "button_checkout": "Ödeme Yap",
      "empty": "Sepetiniz şu anda boş.",
      "continue_browsing_html": "Alışverişe devam et <a href=\"\/collections\/all\">İşte<\/a>.",
      "view_cart": "Sepeti Görüntüle",
      "close_cart": "Sepeti Kapat",
      "shopping_cart": "Alışveriş Sepeti",
      "label": "Not",
      "label_text": "Ek Yorumlar",
      "shipping_calculator_button": "Kargoyu hesapla",
      "shipping_calculator_calculating": "Hesaplanıyor...",
      "shipping_calculator_error_message": "Hata: Lütfen doğru gönderim bilgilerini giriniz",
      "shipping_calculator_success_one_rate": "Için kullanılabilir bir nakliye oranı var",
      "shipping_calculator_success_no_rate": "Bu sipariş ve varış noktası için gönderim ücreti yoktur.",
      "shipping_calculator_success_at": "en",
      "shipping_calculator_success_many_rates": {
        "there_are": "Var",
        "shipping_rates_available_for": "nakliye ücretleri",
        "starting_at": ", Buradan başlayarak"
      }
    },
    "label": {
      "product": "Ürün",
      "price": "Fiyat",
      "quantity": "Miktar",
      "total": "Genel Toplam",
      "or": "veya"
    },
    "ajax_cart": {
      "continue_shopping": "Alışverişe devam et",
      "go_to_cart": "Sepete git",
      "success_text": "alışveriş sepetinize eklendi.",
      "error": "Hata",
      "loading": "Yükleniyor",
      "close": "Kapat"
    }
  },
  "slideshow": {
    "next_slide": "Sonraki slayt",
    "previous_slide": "Bir onceki slayt",
    "pause_slideshow": "Slayt gösterisini duraklat",
    "play_slideshow": "Slayt gösterisini oynat",
    "play_video": "Video oynatmak",
    "close_video": "Video kapat"
  },
  "customer": {
    "account": {
      "title": "Hesabım",
      "details": "hesap detayları",
      "view_addresses": "Adresleri Görüntüle",
      "return": "Hesap Ayrıntılarına Dön"
    },
    "activate_account": {
      "title": "Aktif hesap",
      "subtext": "Hesabınızı etkinleştirmek için şifrenizi oluşturun.",
      "password": "Parola",
      "password_confirm": "Şifreyi Onayla",
      "submit": "Aktif hesap",
      "cancel": "Davetiye Reddet"
    },
    "addresses": {
      "title": "Adresleriniz",
      "default": "Varsayılan",
      "add_new": "Yeni bir adres ekleyin",
      "edit_address": "Adresi düzelt",
      "first_name": "İsim",
      "last_name": "Soyadı",
      "company": "şirket",
      "address1": "Adres1",
      "address2": "Adres2",
      "city": "Kent",
      "country": "ülke",
      "province": "il",
      "zip": "Posta \/ Posta Kodu",
      "phone": "Telefon",
      "set_default": "Varsayılan adres olarak ayarla",
      "add": "Adres Ekle",
      "update": "Adresi Güncelle",
      "cancel": "İptal etmek",
      "edit": "Düzenle",
      "delete": "sil",
      "delete_message": "Bu adresi silmek istediğinden emin misin?"
    },
    "login": {
      "title": "müşteri girişi",
      "email": "E-posta",
      "password": "Parola",
      "forgot_password": "Parolanızı mı unuttunuz?",
      "sign_in": "Oturum aç",
      "login": "Oturum aç",
      "cancel": "Mağazaya Dön",
      "guest_title": "Misafir olarak devam et",
      "guest_continue": "Devam et"
    },
    "orders": {
      "title": "Sipariş Geçmişi",
      "order_number": "Sipariş",
      "date": "Tarih",
      "payment_status": "Ödeme durumu",
      "fulfillment_status": "Tamamlama Durumu",
      "total": "Genel Toplam",
      "none": "Henüz sipariş vermediniz."
    },
    "order": {
      "title": "Sipariş {{ name }}",
      "date": "Yer almak {{ date }}",
      "cancelled": "Sipariş İptal edildi {{ date }}",
      "cancelled_reason": "Sebep:  {{ reason }}",
      "billing_address": "Fatura Adresi",
      "payment_status": "Ödeme durumu",
      "shipping_address": "Teslimat Adresi",
      "fulfillment_status": "Tamamlama Durumu",
      "discount": "İndirim",
      "shipping": "Nakliye",
      "tax": "Vergi",
      "product": "Ürün",
      "sku": "SKU",
      "price": "Fiyat",
      "quantity": "Miktar",
      "total": "Genel Toplam",
      "fulfilled_at": "Karşılanan {{ date }}",
      "subtotal": "Ara toplam"
    },
    "recover_password": {
      "title": "Şifrenizi sıfırlayın",
      "email": "E-posta",
      "submit": "Gönder",
      "cancel": "İptal et",
      "subtext": "Şifrenizi sıfırlamak için size bir e-posta göndereceğiz.",
      "success": "Şifrenizi güncellemek için  bağlantı içeren bir e-posta gönderdik."
    },
    "reset_password": {
      "title": "Hesap şifresini sıfırla",
      "subtext": "Için yeni bir şifre girin {{ email }}",
      "password": "Parola",
      "password_confirm": "Şifreyi Onayla",
      "submit": "Şifreyi yenile"
    },
    "register": {
      "title": "Hesap aç",
      "first_name": "İsim",
      "last_name": "Soyadı",
      "email": "E-posta",
      "password": "Parola",
      "submit": "Hesap oluştur",
      "cancel": "Mağazaya Dön"
    },
    "form": {
      "error_message": "Üzgünüm, bir şeyler ters gitti gibi görünüyor. Lütfen aşağıdakileri düzeltin ve tekrar gönderin:"
    }
  },
  "layout": {
    "cart": {
      "title": "Araba",
      "items_count": {
        "one": "madde",
        "other": "ürün"
      }
    },
    "customer": {
      "account": "hesap",
      "logged_in_as_html": "olarak giriş yaptı {{ first_name }}",
      "log_out": "Çıkış Yap",
      "log_in": "oturum aç",
      "create_account": "Hesap oluştur"
    },
    "footer": {
      "linklist_title": "Hızlı Linkler",
      "social_title": "Bağlanın",
      "newsletter_title": "Bülten",
      "accepted_payments": "Kabul Edilen Ödemeler"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Önceki Ürün",
      "next_product_html": "Sonraki ürün &rarr;",
      "from": "itibaren"
    },
    "product": {
      "sale": "Satış",
      "sold_out": "Satıldı",
      "on_sale_from_html": "<strong>Satılık<\/strong> itibaren {{ price }}",
      "unavailable": "Kullanım dışı",
      "compare_at": "Ile karşılaştır",
      "quantity": "miktar",
      "add_to_cart": "Sepete ekle",
      "select_options": "Seçenekleri seç",
      "quick_view": "Hızlı Görünüm",
      "in_stock": "Stokta var",
      "out_of_stock": "Stoklar tükendi",
      "many_in_stock": "Stoktaki birçok",
      "from": "itibaren"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "İşte {{shop}} için {{value}} hediye kartınız!",
      "subtext": "İşte hediye kartın!",
      "disabled": "Uygun değil",
      "expired": "Süresi doldu {{ expiry }}",
      "active": "Tarihinde sona eriyor {{ expiry }}",
      "redeem": "Hediye kartınızı kullanmak için bu kodu ödeme sırasında kullanın",
      "shop_link": "Alışverişe başla",
      "print": "Yazdır"
    }
  },
  "wishlist": {
    "general": {
      "my_wishlist": "Benim dilek listem",
      "product_image": "Ürün resmi",
      "product_name": "Ürün adı",
      "unit_price": "Birim fiyat",
      "share_wishlist": "İstek listemi e-postayla paylaş",
      "no_login_html": "İstek listesi oluşturmak için <a href=\"\/account\/login\"> oturum açmanız <\/a> veya <a href=\"\/account\/register\"> bir hesap oluşturmanız <\/a> gerekir.",
      "add_to_wishlist": "İstek listesine ekle",
      "added_to_wishlist": "İstek listesine eklendi",
      "note": "Zaten istek listenizde, İstek listesine git",
      "subtext": "Dilek listesi oluşturmak için",
      "sign_in": "oturum aç",
      "or": "veya",
      "create_account": "hesap oluştur"
    },
    "ajax_wishlist": {
      "go_to_wishlist": "İstek Listesine Git",
      "success_text": "İstek listenize eklendi."
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "shopify": {
    "notices": {
      "customer": {
        "password_reset_error": "Şifre resetleme hatası. \/ Password reset error ",
        "no_account_found": "Bu e-mail adresine bağlı kayıt bulunamadı. \/ No account found with that email. ",
        "invalid_credentials": "Geçersiz bilgi girdiniz. \/ Invalid login credentials. "
      },
      "address": {
        "updated": "Adresiniz başarı ile güncellendi. \/ Successfully updated address. ",
        "error_updating": "Hatalı adres güncellemesi. \/ Error updating address ",
        "created": "Adres doğru bir şekilde oluşturuldu. \/ Successfully created address ",
        "error_creating": "Adres oluşturma hatalı. \/ Error creating address. ",
        "deleted": "Adres doğru bir şekilde silindi. \/ Successfully deleted address ",
        "error_deleting": "Adres silme hatalı. \/ Error deleting address. "
      },
      "order": {
        "not_available": "Bu sipariş mevcut değildir. \/ This order is not available ",
        "financial_status": {
          "pending": "Beklemede. \/ Pending ",
          "authorized": "Onay Verildi. \/ Authorized ",
          "paid": "Ödendi. \/ Paid ",
          "unpaid": "Ödenmedi. \/ Unpaid ",
          "voided": "Ret Edildi. \/ Voided ",
          "partially_paid": "Bir kısım ödeme yapıldı. \/ Partially paid ",
          "partially_refunded": "Bir kısım iade edildi. \/ Partially refunded ",
          "refunded": "İade edildi. \/ Refunded "
        },
        "fulfillment_status": {
          "complete": "Tamamlandı. \/ Fulfilled ",
          "partial": "Kısmen \/ Partial ",
          "fulfilled": "Tamamlanmış. \/ ",
          "unfulfilled": "Tamamlanmamış. \/ Unfulfilled ",
          "restocked": "Stoğa yeniden geldi. \/ Restocked"
        },
        "transaction_status": {
          "success": "Mükemmel. \/ Success ",
          "pending": "Beklemede. \/ Pending ",
          "failure": "Başarısız. \/ Failure",
          "error": "Hata. \/ Error "
        },
        "cancel_reason": {
          "declined": "Ödeme Ret edildi. \/ Payment declined ",
          "inventory": "Ürünler mevcut değil. \/ Items unavailable ",
          "fraud": "Hileli Sipariş. \/ Fraudulent order ",
          "customer": "Sipariş değiştirildi \/ iptal edildi. \/ Customer changed\/cancelled order ",
          "other": "Diğer \/ Other "
        }
      },
      "cart": {
        "all_items_in_cart": "Tüm {{ count }} {{ name }} sepetinizdedir. \/ All {{ count }} {{ name }} are in your cart. ",
        "only_n_items_available": "Sadece {{ count }} {{ name }} sepetinize ekleyebilirsiniz.  \/ You can only add {{ count }} {{ name }} to the cart",
        "empty_update": "Boş sepetler güncellenemez. \/ cannot update empty cart ",
        "missing_parameters": "Geçersiz kullanıcı id yada parametre hatalı \/ no valid id or line parameter ",
        "generic_error": "Sepet Hatası \/ Cart Error ",
        "too_many_line_items_error": "Sepetinizde {{ max }} dan fazla ürün eklenemez.  \/ Your cart can't contain more than {{ max }} items. ",
        "link_expired": "Link Zaman aşımına uğramıştır. \/ Link expired ",
        "link_no_longer_exists": "Link uzun süredir erişilmezdir. \/ Link no longer exists. ",
        "stock_problems_html": "Bir veya daha fazla ürün mevcut değildir.   Öneri olarak<a href='{{ link }}'>Güncellenen sepet<\/a>.  \/ One or more items are no longer available. We've provided an <a href='{{ link }}'>updated cart<\/a>. ",
        "changed": "Sepet içerik değişti. \/ Cart changed ",
        "items_changed": "Bir veya dagha fazla ürün değişti. \/ One or more items have changed. ",
        "product_sold_out": "Ürünümüz '{{ name }}' stokta bitmiştir.  \/ The product '{{ name }}' is already sold out. ",
        "variant_not_found": "Çeşitleri Bulunamamıştır. \/ Cannot find variant ",
        "shipping_address_not_required": "Bu sepet kargo gerektirmemektedir. \/ This cart does not require shipping ",
        "shipping_address_invalid": "Geçersiz kargolama adresi. \/ Invalid shipping address "
      },
      "storefront": {
        "invalid_password": "Yanlış şifre girdiniz, lütfen tekrar deneyiniz. \/ Password incorrect, please try again. "
      }
    },
    "sentence": {
      "two_words_connector": "ve \/ and ",
      "last_word_connector": ", ve \/ , and ",
      "words_connector": ","
    },
    "pagination": {
      "previous": "Önceki \/ Previous ",
      "next": "Sonraki \/ Next "
    },
    "links": {
      "learn_more": "Daha fazlası... \/ Learn more ",
      "powered_by_shopify": "Shopify tarafından geliştirilmiştir \/ Powered by Shopify "
    },
    "dates": {
      "abbr_day_names": {
        "sunday": "Pazar \/ Sun",
        "monday": "Pazartesi \/ Mon",
        "tuesday": "Salı \/ Tue",
        "wednesday": "Çarşamba \/ Wed",
        "thursday": "Perşembe \/ Thu",
        "friday": "Cuma  \/ Fri",
        "saturday": "Cumartesi \/ Sat"
      },
      "day_names": {
        "sunday": "Pazar \/ Sunday",
        "monday": "Pazartesi \/ Monday",
        "tuesday": "Salı \/ Tuesday",
        "wednesday": "Çarşamba \/ Wednesday",
        "thursday": "Perşembe \/ Thursday",
        "friday": "Cuma \/ Friday ",
        "saturday": "Cumartesi \/ Saturday "
      },
      "abbr_month_names": {
        "january": "Ocak \/ Jan ",
        "february": "Şubat \/ Feb ",
        "march": "Mart \/ Mar ",
        "april": "Nisan \/ Apr",
        "may": "Mayıs \/ May",
        "june": "Haziran \/ Jun",
        "july": "Temmuz \/ Jul",
        "august": "Ağustos \/ Aug",
        "september": "Eylül \/ Sep",
        "october": "Ekim \/ Oct",
        "november": "Kasım \/ Nov",
        "december": "Aralık \/ Dec"
      },
      "month_names": {
        "january": "Ocak \/ January ",
        "february": "Şubat \/ February ",
        "march": "Mart \/ March ",
        "april": "Nisan \/ April ",
        "may": "Mayıs \/ May ",
        "june": "Haziran \/ June ",
        "july": "Temmuz \/ July",
        "august": "Ağustos \/ August ",
        "september": "Eylül \/ September ",
        "october": "Ekim \/ October ",
        "november": "Kasım \/ November ",
        "december": "Aralık \/ December "
      },
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z ",
        "long": "%B %d, %Y %H:%M ",
        "short": "%d %b %H:%M ",
        "month_day": "%B %-d "
      },
      "am": "am",
      "pm": "pm"
    },
    "page_titles": {
      "products": "Ürünler \/ Products ",
      "shopping_cart": "Alışveriş Sepetiniz \/ Your Shopping Cart ",
      "account": "Üyelik \/ Account ",
      "create_account": "Üyelik Oluştur \/ Create Account ",
      "reset_account": "Üyeliği Yenile \/ Reset Account ",
      "addresses": "Adresler \/ Addresses ",
      "order": "Sipariş {{ name }}  \/ Order {{ name }} ",
      "search": "Arama \/ Search ",
      "collections": "Koleksiyonlar \/ Collections ",
      "not_found": "404 Hatası Bulunamadı \/ 404 Not Found ",
      "challenge": "Challenge  \/ Challenge "
    },
    "cart": {
      "discounts_with_count": "{{ count }} indirim uygulanmıştır. \/ {{ count }} discounts have been applied "
    },
    "challenge": {
      "message": "Devam etmek için Robot olmadığınızı doğrulayın. \/ To continue, let us know you're not a robot. ",
      "error": "Cevabınız yanlıştır, Tekrar deneyiniz. \/ Your answer wasn't correct, please try again. ",
      "submit_button_text": "Onayla \/ Submit "
    },
    "checkout": {
      "general": {
        "continue_button_label": "Devam et \/ Continue ",
        "complete_purchase_button_label": "Alışverişi Tamamla \/ Complete order ",
        "page_title": "Ödeme \/ Checkout ",
        "edit_link_label": "Düzenle \/ Edit ",
        "all_rights_reserved": "Bütün Hakları saklıdır {{ shop_name }}  \/ All rights reserved {{ shop_name }} ",
        "print_policies_link_label": "Yazdır \/ Print ",
        "cart": "Sepet \/ Cart ",
        "close_modal_label": "Kapalı \/ Close ",
        "continue_to_shipping_method": "Kargo yöntemi için devam ediniz \/ Continue to shipping method ",
        "continue_to_payment_method": "Ödeme yöntemi için devam ediniz \/ Continue to payment method ",
        "continue_to_review": "Siparişi incele \/ Review order ",
        "back_to_cart": "Sepete geri dön \/ Return to cart ",
        "back_to_contact_information": "Müşteri bilgilerine geri dön \/ Return to customer information ",
        "back_to_shipping_method": "Kargo yöntemine geri dön \/ Return to shipping method ",
        "back_to_payment_method": "Ödeme yöntemine geri dön \/ Return to payment methods ",
        "edit_shipping_address": "Kargo adresini düzenle \/ Edit shipping address ",
        "edit_contact_information": "Müşteri bilgilerini düzenle \/ Edit customer information ",
        "edit_shipping_method": "Kargo yöntemini düzenle \/ Edit shipping method ",
        "edit_payment_method": "Ödeme yöntemini düzenle \/ Edit payment method ",
        "edit_billing_address": "Fatura adresini düzenle \/ Edit billing address ",
        "choose_shipping_method": "Kargolama yöntemi seçiniz \/ Choose a shipping method ",
        "choose_payment_method": "Ödeme yöntemi seçiniz \/ Choose a payment method ",
        "choose_billing_address": "Fatura adresi seçiniz \/ Choose a payment method ",
        "contact_us_html": "Daha fazla bilgi için bizimle iletişime geçiniz. \/ Contact us for more information ",
        "autocomplete_title": "Öneriler \/ Suggestions ",
        "autocomplete_single_item": "1 ürün mevcut \/ 1 item available ",
        "autocomplete_multi_item": "{{number}} ürün mevcut \/ {{number}} items available ",
        "autocomplete_selection": "{{total}} adetten {{number}} tanesi \/ {{number}} of {{total}} ",
        "forwarding_indicator": {
          "new_window": "Yeni pencerede açılır \/ Opens in a new window. ",
          "external": "Yeni sitede açılır \/ Opens external website. ",
          "external_and_new_window": "Yeni site penceresinde açılır.  \/ Opens external website in a new window. "
        },
        "footer": "En alt  \/ Footer ",
        "checkout_context": {
          "step_one": "{{ shop_name }} - Ödeme \/ {{ shop_name }} - Checkout "
        }
      },
      "contact": {
        "title": "Müşteri Bilgileri \/ Customer information ",
        "address_title": "Adres \/ Address ",
        "country_placeholder": "Ülke \/ Country ",
        "shipping_address_title": "Kargo adresi \/ Shipping address ",
        "contact_method_title": "İletişim Bilgileri \/ Contact information ",
        "email_label": "E-posta \/ Email ",
        "email_placeholder": "E-Posta \/ Email ",
        "email_or_phone_label": "E-posta ve Cep telefon numarası \/ Email or mobile phone number ",
        "email_or_phone_placeholder": "E-posta ve Ev\/İş telefon numarası \/ Email or mobile phone number ",
        "stored_addresses_label": "Kayıtlı Adres \/ Stored addresses ",
        "new_address_label": "Yeni adres \/ New address… ",
        "first_name_label": "Adınız \/ First name ",
        "optional_first_name_label": "Birinci adınız ( opsiyonel ) \/ First name (optional) ",
        "first_name_placeholder": "Birinic adınız \/ First name ",
        "optional_first_name_placeholder": "Birinci adınız ( opsiyonel ) \/ First name (optional) ",
        "last_name_label": "Soyadınız \/ Last name ",
        "last_name_placeholder": "Soyadınız \/ Last name ",
        "company_label": "Firma Bilgileri \/ Company ",
        "optional_company_label": "Firma Bilgileri ( Opsiyonel ) \/ Company (optional) ",
        "company_placeholder": "Firma Bilgileri \/ Company ",
        "optional_company_placeholder": "Firma Bilgileri ( Opsiyonel ) \/ Company (optional) ",
        "address1_label": "Adres \/ Address ",
        "address1_placeholder": "Adres \/ Address ",
        "address2_label": "Apt. Bina. ... \/ Apt, suite, etc. ",
        "optional_address2_label": "Apt. Bina. ... ( opsiyonel ) \/ Apt, suite, etc. (optional) ",
        "address2_placeholder": "Apt. Bina. ... \/ Apt, suite, etc. ",
        "optional_address2_placeholder": "Apt. Bina. ... ( opsiyonel ) \/ Apt, suite, etc. (optional) ",
        "city_label": "Şehir \/ City ",
        "city_placeholder": "Şehir \/ City ",
        "country_label": "Ülke \/ Country ",
        "country_code": "Ülke Kodu \/ Country code ",
        "province_label": "Bölge \/ Province ",
        "province_placeholder": "Bölge \/ Province ",
        "phone_label": "Telefon \/ Phone ",
        "optional_phone_label": "Telefon ( Opsiyonel ) \/ Phone (optional) ",
        "phone_placeholder": "Telefon  \/ Phone ",
        "optional_phone_placeholder": "Telefon ( Opsiyonel ) \/ Phone (optional) ",
        "zip_code_placeholder": "Zip kodu \/ Zip code ",
        "postal_code_placeholder": "Posta kodu \/ Postal code ",
        "postcode_placeholder": "Posta Kodu \/ Postcode ",
        "pincode_placeholder": "Pin Kodu \/ Pincode "
      },
      "customer_account": {
        "not_user_label": "Değilmisiniz {{ first_name }}?  \/ Not {{ first_name }}? ",
        "have_an_account_label": "Hesabım Var \/ Already have an account? ",
        "sign_in_link_label": "Giriş yap \/ Log in ",
        "sign_out_link_label": "Çıkış Yap \/ Log out ",
        "save_my_information_label": "Bu bilgiyi sonrası için sakla \/ Save this information for next time  "
      },
      "stock": {
        "page_title": "Envanter Problemi \/ Inventory issues ",
        "title": "Envanter Problemi \/ Inventory issues ",
        "items_unavailable_notice": "Bazı ürünler erişilemez ve sepetiniz güncellenmiştir. Uygunsuz durum için özür dileriz. \/ Some products became unavailable and your cart has been updated. We're sorry for the inconvenience. ",
        "product_column_header": "Ürünler \/ Products ",
        "quantity_column_header": "Miktar \/ Quantity ",
        "price_column_header": "Fiyat \/ Price ",
        "status_column_header": "Durum \/ Status ",
        "removed_from_cart_notice": "Sepetinizden silinmiştir. \/ Removed from cart ",
        "sold_out_label": "Ürün bitmiştir. \/ Sold out ",
        "reduced_label": "Düşürüldü. \/ Reduced ",
        "reduced_with_quantity_label": "Sadece {{ quantity_available }} kaldı \/ Only {{ quantity_available }} left ",
        "remove_from_cart_button_label": "Sepetinizden silinmiştir. \/ Remove from cart ",
        "continue_shopping_button_label": "Devem et \/ Continue ",
        "go_back_to_cart_button_label": "Sepetime geri dön \/ Go back to my cart "
      },
      "order_summary": {
        "title": "Sipariş toplamı \/ Order summary ",
        "order_name_label": "Sipariş {{ name }}  \/ Order {{ name }} ",
        "shopping_cart_label": "Alışveriş Sepeti \/ Shopping cart ",
        "discount_title": "İndirim \/ Discount ",
        "discount_label": "İndirim \/ Discount ",
        "discount_placeholder": "İndirim \/ Discount ",
        "gift_card_title": "Hediye Kartı \/ Gift card ",
        "gift_card_label": "Hediye Kartı \/ Gift card ",
        "gift_card_placeholder": "Hediye Kartı \/ Gift card ",
        "gift_card_and_discount_title": "Hediye kartı veya indirim kuponu \/ Gift card or discount code ",
        "gift_card_and_discount_label": "Hediye kartı veya indirim kuponu \/ Gift card or discount code ",
        "gift_card_and_discount_placeholder": "Hediye kartı veya indirim kuponu \/ ",
        "show_discount_form_link_label": "İndirim Kuponunuz mu var? Girmek için burayı tıklayınız. \/ ",
        "remove_gift_card_label": "Hediye kartını temizle \/ Have a discount code? Click here to enter it ",
        "remove_discount_label": "İndirimi kaldır.  \/ Remove discount ",
        "free_shipping_discount_label": "Ücretsiz Kargo \/ Free shipping ",
        "apply_discount_button_label": "Uygula \/ Apply ",
        "applied_discount_message": "{{ amount }} toplam siparişe uygulanmıştır \/ {{ amount }} off total order price ",
        "cart_does_not_meet_discount_requirements_notice": "Sepetiniz {{ code }} indirim kodu için gerekli şartları karşılamamaktadır.  \/ Your cart does not meet the requirements for the {{ code }} discount code ",
        "discount_requires_customer_notice": "Lütfen  {{ code }} indirim kodu uygulaması için gerekli kargo bilgilerini giriniz. \/ Please submit your shipping information to apply the {{ code }} discount code ",
        "customer_does_not_meet_discount_requirements_notice": "Müşteri bilgileriniz {{ code }} indirim kodu için gerekli şartları karşılamamaktadır.  \/ Customer information does not meet the requirements for the {{ code }} discount code ",
        "shipping_information_does_not_meet_discount_requirements_notice": "Kargo bilgileriniz {{ code }} indirim kodu için gerekli şartları karşılamamaktadır.  \/ Your shipping information does not meet the requirements for the {{ code }} discount code ",
        "customer_already_used_once_per_customer_discount_notice": "Bu {{ code }} indirim Kodu daha önce kullanılmıştır.  \/ The {{ code }} discount code has already been used ",
        "subtotal_label": "Ara Toplam \/ Subtotal ",
        "shipping_label": "Kargolama \/ Shipping ",
        "shipping_pending_message": "Şuan mevcut değildir. \/ Not yet available ",
        "taxes_label": "Vergiler \/ Taxes ",
        "total_label": "Toplam \/ Total ",
        "partial_total_label": "Toplam \/ Total ",
        "free_total_label": "Ücretsiz \/ Free ",
        "paid_label": "Ödendi \/ Paid ",
        "payment_due_label": "Ödeme  vadesi \/ Payment due ",
        "vat_label_html": " {{ amount }} vergi olarak eklenmiştir ",
        "discount_and_gift_card_savings_notice": "Sonra {{ discount_amount }} indirimlerdeki ve {{ gift_card_amount }} hediye kartlarındaki \/ After {{ discount_amount }} in discounts and {{ gift_card_amount }} in gift cards ",
        "cost_table_title": "Maliyet toplamı \/ Cost summary ",
        "description_label": "Açıklama \/ Description ",
        "price_label": "Fiyat \/ Price ",
        "quantity_label": "Miktar \/ Quantity ",
        "product_image_label": "Ürün Resmi \/ Product image ",
        "scroll_order_summary": "Daha çok ürün için kaydırın \/ Scroll for more items ",
        "expand_order_summary": "Sipariş toplamını göster \/ Show order summary ",
        "collapse_order_summary": "Sipariş toplamını gizle \/ Hide order summary ",
        "total_updated_label": "Güncellenmiş toplam fiyat \/ Updated total price: ",
        "discount_savings_notice": "Sonra {{ discount_amount }} indirimlerdeki \/ After {{ discount_amount }} in discounts ",
        "gift_card_savings_notice": "Sonra {{ gift_card_amount }} hediye kartlarındaki \/ After {{ gift_card_amount }} in gift cards ",
        "tip_label": "Tip \/ Tip ",
        "shipping_pending_value": "--"
      },
      "shipping": {
        "title": "Kargo methodu \/ Shipping method ",
        "shipping_method_title": "Kargo methodu \/ Shipping method ",
        "waiting_on_rate_notice": "Lütfen uygun kargolama hesaplanırken bekleyiniz \/ Please wait while we fetch available shipping rates… ",
        "no_rates_for_cart_or_destination_notice": "Sepetiniz ve Bölgeniz için kargolama methodu bulunamamıştır. \/ There are no shipping methods available for your cart or destination. ",
        "no_rates_for_country_notice": " {{ country }} bölgenize kargolama yapamıyoruz.  \/ We don't offer shipping to {{ country }}. ",
        "no_rates_contact_notice": "Daha fazla bilgi için bizimle iletişime geçiniz. \/ Contact us for more information ",
        "free_rate_label": "Ücretsiz \/ Free ",
        "cheapest_rate_label": "En Ucuz \/ Cheapest ",
        "please_enter_your_shipping_information_notice": "Lütfen kargolama bilgilerinizi giriniz \/ Please enter your shipping information. ",
        "estimated_delivery_date_range": "{{ minimum }} ila {{ maximum }} iş günü \/ {{ minimum }} to {{ maximum }} business days ",
        "shipping_line_phone_label": "Cep telefonu numarası ( Gerekli ) \/ Mobile phone number (required) ",
        "shipping_line_phone": "Taşıyıcı firma bu numara ile sizinle iletişime geçebilir. \/ Your courier may use this number to contact you. ",
        "shipping_rate_discounted_amount": "önceden: {{ original_amount }}. şimdi: {{ amount }}  \/ Was: {{ original_amount }}. Now: {{ amount }} ",
        "estimated_delivery_date": {
          "one": "1 iş Günü \/ 1 business day ",
          "other": "{{ count }} iş Günü \/ {{ count }} business days "
        },
        "other_method": {
          "zero": "Başka method bulunamamıştır \/ No other methods available ",
          "one": "1 adet uygun method bulunmuştur. \/ 1 other method available at ",
          "other": "{{ count }} adet method bulunmuştur. \/ {{ count }} other methods available starting at "
        }
      },
      "payment": {
        "title": "Ödeme Şekli \/ Payment method ",
        "amount_left_to_pay_label": "Ödeme zamanı: \/ Payment due: ",
        "discount_button_action_label": "İndirim Kodu uygula \/ Apply Discount Code ",
        "gift_card_code_label": "Hediye kart kodu \/ Gift card code ",
        "apply_gift_card_button_label": "Uygula \/ Apply ",
        "gift_card_balance_label": "Kalan miktar: \/ Balance: ",
        "show_gift_card_form_link_label": "Hediye kartınızmı var? Giriş için tıklayınız \/ Have a gift card? Click here to enter it ",
        "supported_card_brands_more_label": "Daha Fazlası... \/ and more… ",
        "detected_card_brand": "Tanımlanmış kart: {brand}  \/ Detected card brand: {brand} ",
        "card_number_label": "Kart Numarası \/ Card number ",
        "card_number_placeholder": "Kart Numarası \/ Card number ",
        "card_pay_with": "Bununla öde: \/ Pay with: ",
        "card_security_notice": "Bütün ödemeler güvenli ve şifrelidir. \/ All transactions are secure and encrypted. ",
        "name_on_card_label": "Kart sahibi \/ Cardholder name ",
        "name_on_card_placeholder": "Kart sahibi \/ Cardholder name ",
        "card_expiry_month_label": "Son kullanma AY \/ Expiry month ",
        "card_expiry_month_placeholder": "AA \/ MM ",
        "card_expiry_year_label": "Son Kullanma YILI \/ Expiry year ",
        "card_expiry_year_placeholder": "YY \/ YY ",
        "card_expiry_label": "Son Kullanma \/ Expiry ",
        "card_expiry_short_label": "AA \/ YY \/ MM \/ YY ",
        "card_expiry_long_label": "Son Kullanma (AA \/YY) \/ Expiry (MM \/ YY) ",
        "card_expiry_placeholder": "AA \/ YY \/ MM \/ YY ",
        "card_expiry_date_explanation": "Kart Son kullanım tarihi formatı: ay, ay, yıl, yıl \/ Card expiration date in format: month, month, year, year ",
        "card_verification_value_explanation": "3- haneli güvenlik kodu kartınızın arka yüzündedir. Amerikan Express kartlarında 4-haneli ve ön yüzündedir. \/ 3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front. ",
        "card_verification_value_explanation_amex": "4-haneli güvenlik kodu kartınızın ön yüzündedir. \/ 4-digit security code on the front of your card ",
        "card_verification_value_explanation_other": "3-haneli güvenlik kodu kartınızın arka yüzündedir. \/ 3-digit security code on the back of your card ",
        "card_start_month_label": "Başlangıç Ayı \/ Start month ",
        "card_start_month_placeholder": "AA \/ MM ",
        "card_start_year_label": "Başlangıç Yılı \/ Start year ",
        "card_start_year_placeholder": "YY \/ YY ",
        "card_start_label": "Başlangıç \/ Start ",
        "amazon_payments_label": "Amazon ödeme \/ Amazon Pay ",
        "amazon_payments_login_hint": "Amazon ile giriş yapıp sorabilirsiniz. \/ You will be asked to login with Amazon. ",
        "amazon_payments_logout": "Amazon ödemesinden çıkın \/ Log out from Amazon Pay ",
        "card_start_long_label": "Veriliş tarihi (MM \/ YY)  \/ Issue date (MM \/ YY) ",
        "card_start_placeholder": "MM \/ YY  \/ MM \/ YY ",
        "card_issue_number_label": "Kart veriliş numarası \/ Issue number ",
        "card_issue_number_placeholder": "Kart veriliş numarası \/ Issue number ",
        "card_change_label": "Değiştir \/ Change ",
        "ends_with_label": "son haneler {{ last_digits }}  \/ ending with {{ last_digits }} ",
        "saved_by_payment_method": "olarak kaydedildi {{ payment_method }}  \/ Saved by {{ payment_method }} ",
        "pay_with_payment_method": "{{ payment_method }} ile öde  \/ Pay with {{ payment_method }} ",
        "same_billing_address_label": "Kargo adresi ile aynı \/ Same as shipping address ",
        "different_billing_address_label": "Farklı bir fatura adresi kullan \/ Use a different billing address ",
        "free_order_notice_html": "Siparişiniz <strong>ücretsizdir<\/strong>. Ödeme gerekli değildir. \/ Your order is <strong>free<\/strong>. No payment is required. ",
        "offsite_gateway_redirect_hint": "Tıkladıktan sonra \"{{ button_label }}\", yönlendirileceksiniz {{ gateway_label }} ödemenizi güvenli bir şekilde tamamlamanız için.  \/ After clicking \"{{ button_label }}\", you will be redirected to {{ gateway_label }} to complete your purchase securely. ",
        "billing_address_title": "Fatura adresi \/ Billing address ",
        "no_js_credit_card_fields_redirect_hint": "Ödeme bilgileri girişi için ödeme alanına yönlendirileceksiniz.  \/ You will be redirected to a payment gateway in order to add your payment information. ",
        "card_fields_container_prefix": "Alan içeriği: \/ Field container for: ",
        "card_fields_processing_error": "Ödeme işlemi sırasında bir hata meydana geldi. Sonra tekrar deneyiniz. \/ An error occurred while processing the payment information. Please try again later. ",
        "technical_error": "Ödeme işlemi teknik sorunlar sebebi ile şuan gerçekleştirilemiyor. Kısa bir süre içinde yeniden deneyiniz. \/ Payments can't be processed right now because of technical problems. Please try again in a few minutes. ",
        "no_method_error": "Bulunduğunuz bölge yada sepetinizdeki ürünlerden dolayı ödeme yöntemi uygun değildir. \/ Based on your location or products in your cart, there are no payment methods available. ",
        "not_configured_error": "Ödeme yöntemi oluşturulmamıştır. \/ No payment gateway currently configured. ",
        "missing_credit_card_error": "Kredi kartsız işlem gerçekleştirilemez \/ Cannot process a payment without a credit card ",
        "generic_incorrect_card_info": "Vermiş olduğunuz bilgiler doğrulanamıyor. Lütfen kart bilgilerinizi kontrol edip yeniden deneyiniz \/ The information you provided couldn't be verified. Please check your card details and try again. ",
        "order_covered_by_gift_cards_notice": {
          "one": "Siparişiniz hediye kartınız tarafından karşılanıyor. \/ Your order is covered by your gift card. ",
          "other": "Siparişiniz hediye kartınız tarafından karşılanıyor. \/ Your order is covered by your gift cards. "
        },
        "card_fields_unavailable_html": {
          "one": "Kredi kartı yada Banka kartı ödemeleri şuan için uygun değildir.<br>Lütfen <a href=\"javascript:window.location.reload();\">Sayfayı yenile<\/a> yada daha sonra deneyiniz.  \/ Credit and Debit card payments aren't available right now.<br>Please <a href=\"javascript:window.location.reload();\">refresh this page<\/a> or try again later. ",
          "other": "Kredi kartı yada Banka kartı ödemeleri şuan için uygun değildir.<br>Lütfen <a href=\"javascript:window.location.reload();\">Sayfayı yenile<\/a> yada daha sonra deneyiniz.  \/ Credit and Debit card payments aren't available right now.<br>Please <a href=\"javascript:window.location.reload();\">refresh this page<\/a> or try a different payment method. "
        },
        "card_verification_value_label": "CVV \/ CVV ",
        "card_verification_value_placeholder": "CVV \/ CVV "
      },
      "payment_summary": {
        "gift_card_current_balance_notice": "Şuanki bakiye {{ amount }}  \/ Current balance {{ amount }} ",
        "credit_card_expires_on_notice": "{{ month }}\/{{ year }} içinde son kullanım \/ Expires on {{ month }}\/{{ year }} ",
        "express_payment_gateway_label": "Express  \/ Express ",
        "manual_payment_gateway_label": "Elle \/ Manual ",
        "billing_address_title": "Fatura adresi \/ Billing address ",
        "free_label": "Ücretsiz \/ Free "
      },
      "field_errors": {
        "handle_phone_invalid": "Lütfen geçerli bir telefon numarası giriniz \/ Please enter a valid phone number ",
        "handle_email_invalid": "Lütfen geçerli bir e-posta adresi giriniz \/ Please enter a valid email address ",
        "email_invalid": "Lütfen geçerli bir e-posta adresi giriniz \/ Please enter a valid email address ",
        "email_or_phone_blank": "Lütfen geçerli bir e-posta adresi yada telefon numarası giriniz \/ Please enter your email address or mobile phone number ",
        "email_or_phone_invalid": "Lütfen geçerli bir e-posta adresi yada telefon numarası giriniz \/ Please enter a valid email address or a mobile phone number ",
        "address_first_name_blank": "Lütfen isminizi giriniz \/ Please enter your first name ",
        "address_last_name_blank": "Lütfen soyisminizi giriniz \/ Please enter your last name ",
        "address_address1_blank": "Lütfen adresinizi giriniz \/ Please enter your address ",
        "address_address2_blank": "Lütfen apt, site, vs giriniz  \/ Please enter your apt, suite, etc ",
        "address_city_blank": "Lütfen şehrinizi giriniz \/ Please enter your city ",
        "address_country_blank": "Lütfen ülkenizi giriniz \/ Please select your country ",
        "address_province_blank": "Lütfen eyalet \/ bölge  giriniz \/ Please select your state \/ province ",
        "address_company_blank": "Lütfen şirket isminizi giriniz \/ Please enter a company name ",
        "address_phone_blank": "Lütfen geçerli bir telefon numarası giriniz \/ Please enter a valid phone number ",
        "address_zip_blank": "Lütfen zip\/ posta kodu giriniz \/ Please enter your zip \/ postal code ",
        "address_zip_invalid_for_country": "Lütfen {{ country }} için geçerli bir zip\/ posta kodu giriniz \/ Please enter a valid zip \/ postal code for {{ country }} ",
        "address_zip_invalid_for_country_and_province": "Lütfen {{ country }} için geçerli bir zip\/ posta kodu giriniz \/ Please enter a valid zip \/ postal code for {{ province }}, {{ country }} ",
        "credit_card_name_blank": "Lütfen isminizi kartınızın üzerinde yazan şekilde giriniz \/ Please enter your name as it appears on the card ",
        "credit_card_name_invalid": "Lütfen isminizi kartınızın üzerinde yazan şekilde giriniz \/ Please enter your name as it appears on the card ",
        "credit_card_number_invalid": "lütfen geçerli bir kredi kartı numarası giriniz \/ Please enter a valid credit card number ",
        "credit_card_expiry_invalid": "Lütfen geçerli bir son kullanma tarihi giriniz \/ Please enter a valid expiry date ",
        "credit_card_month_invalid": "Lütfen geçerli bir son kullanma ayı giriniz \/ Please enter a valid expiry month ",
        "credit_card_year_invalid": "Lütfen geçerli bir son kullanma yılı giriniz \/ Please enter a valid expiry year ",
        "credit_card_start_invalid": "Lütfen geçerli bir başlangıç tarihi giriniz \/ Please enter a valid start date ",
        "credit_card_start_month_invalid": "Lütfen geçerli bir başlangıç ayı giriniz \/ Please enter a valid start month ",
        "credit_card_start_year_invalid": "Lütfen geçerli bir başlangıç yılı giriniz \/ Please enter a valid start year ",
        "credit_card_verification_value_blank": "Lütfen CVV giriniz  \/ Please enter the CVV ",
        "reduction_code_code_not_found": "Bu kod aktif bir hediye kartı yada indirim kartı ile uyuşmuyor. Doğru girdiğinize eminmisiniz? \/ This code did not match any active gift card or discount. Was it entered correctly? ",
        "reduction_code_discount_not_found": "Bu kod geçerli bir indirim kodu ile uyuşmuyor  \/ Unable to find a valid discount matching the code entered ",
        "reduction_code_gift_card_code_invalid": "Geçersiz kod \/ Code is invalid ",
        "reduction_code_gift_card_unusable": "Hediye kartı içeren bir siparişte hediye kartı kullanamazsınız.  \/ Cannot use a gift card on an order containing a gift card. ",
        "shipping_line_phone_blank": "Gönderim şekli seçimi için cep telefonu numaranızı girmelisiniz. \/ To use this delivery method, you need to enter your mobile phone number. ",
        "shipping_line_phone_invalid": "Gönderim şekli seçimi için 10 haneli cep telefonu numaranızı girmelisiniz. \/ To use this delivery method, you need to enter a 10 digit mobile phone number. ",
        "gift_card_already_applied": "Bu hediye kartı zaten siparişinize uygulanmıştır. \/ This gift card has already been applied to your order ",
        "gift_card_disabled": "Hediye kartı uzun süredir kullanımda değildir. \/ Looks like this gift card is no longer available ",
        "gift_card_expired": "Hediye kartının kullanım süresi geçmiştir. \/ Looks like this gift card has expired ",
        "gift_card_depleted": "Hediye kartınızda yüklü bakiye kalmamıştır. \/ Looks like there are no remaining funds on this gift card ",
        "gift_card_currency_mismatch": "Sadece {{ checkout_currency }} olarak ödenmiş hediye kartları şiparişinizde kullanılabilir. \/ Only gift cards purchased in {{ checkout_currency }} can be applied to this order ",
        "payment_gateway_needs_paid_plan_error": "Bu siparişi tamamlayabilmek için ödeme planı içinde olmalısınız. \/ To complete this checkout you must be on a paid plan "
      },
      "review": {
        "title": "Siparişi incele \/ Review order ",
        "checkout_as_guest": "Misafir olarak ödeme yap \/ Checkout as guest ",
        "blocks": {
          "billing_address_title": "Fatura \/ Billing ",
          "shipping_address_title": "Buraya Kargola \/ Ship to ",
          "shipping_method_title": "Yöntem \/ Method ",
          "payment_method_title": "Ödeme \/ Payment ",
          "change_link_label": "Değiştir \/ Change ",
          "change_contact_method_link_label": "İletişim bilgilerini değiştir \/ Change contact information ",
          "change_billing_address_link_label": "Fatura adresini değiştir \/ Change billing address ",
          "change_shipping_address_link_label": "Kargo adresini değiştir \/ Change shipping address ",
          "change_shipping_method_link_label": "Kargo yöntemini değiştir \/ Change shipping method ",
          "change_payment_method_link_label": "Ödeme yöntemini değiştir \/ Change payment method ",
          "contact_method_title": "İletişim \/ Contact "
        }
      },
      "newsletter": {
        "subscription_checkbox_label": "Email listemize üye olunuz. \/ Subscribe to our newsletter "
      },
      "marketing": {
        "accept_marketing_checkbox_label": "Beni güncel bilgi ve özel tekliflerden haberdar et \/ Keep me up to date on news and exclusive offers ",
        "unsubscribe": {
          "title": "Kayıttan çıktınız \/ You’ve unsubscribed ",
          "description": "Sepet güncellemelerinden haberdar olmayacaksınız. \/ You won’t receive any more cart reminders from us. "
        }
      },
      "shop_policies": {
        "refund_policy": "İade Politikası \/ Refund policy ",
        "privacy_policy": "Gizlilik Politikası \/ Privacy policy ",
        "terms_of_service": "Hizmet Kulanım Şartları \/ Terms of service "
      },
      "remember_me": {
        "title": "Beni Hatırla \/ Remember me ",
        "label": "Bilgilerimi hızlı ödeme için kaydet \/ Save my information for a faster checkout ",
        "mobile_phone_icon_alt": "Cep Telefonu \/ Mobile phone ",
        "mobile_phone_number": "Cep telefonu numarası \/ Mobile phone number ",
        "modal": {
          "errors": {
            "shipping_address": {
              "title": "Bulunduğunuz bölgeye kargolanamıyor. \/ Unable to ship to your area ",
              "body": "Kayıtlı bilgileriniz Shopify Pay için şuan kullanılamıyor. Devam etmek için normal ödeme yöntemine geçiniz. \/ The information you saved with Shopify Pay can’t be used for this purchase. Please continue to the regular checkout. "
            },
            "authorize": {
              "title": "Shopify ile ödeme geçerli değil. \/ Shopify Pay unavailable ",
              "link": "Lütfen ödeme bilgisi giriniz \/ Enter payment information ",
              "body": "Kayıtlı bilgileriniz şuan kullanılamıyor. Devam etmek için ödeme bilgilerinizi giriniz. \/ Your saved information can’t be used at the moment. Enter your payment information to continue. "
            },
            "enter_valid_code": "Girdiğiniz Kod yanlıştır. \/ The code you entered is incorrect ",
            "enter_a_code": "Lütfen geçerli kod giriniz. \/ Enter a valid verification code ",
            "code_not_received": {
              "body": "Çalışmıyormu? \/ Not working? ",
              "contact_information_step": {
                "link": "Normal ödemem için devam edin. \/ Continue to the regular checkout "
              },
              "payment_information_step": {
                "link": "Kart detaylarını giriniz. \/ Enter card details "
              }
            },
            "server": {
              "title": "Shopify pay geçersizdir. \/ Shopify Pay unavailable ",
              "body": "Kayıtlı bilgileriniz bu tarz ödemede kullanılamaz. Lütfen normal ödeme yöntemini seçiniz. \/ Your saved information can’t be used for this purchase. Please continue to the regular checkout. "
            },
            "throttle": {
              "title": "Deneme limiti aşılmıştır. \/ Attempt limit is reached ",
              "body": "Kod bilgisi çok fazla yanlış girilmiştir. Lütfen normal ödeme yöntemine geçiniz. \/ Your code was incorrectly entered too many times. Please continue to the regular checkout. "
            }
          },
          "guest": {
            "title": "Kayıtlı Bilgilerinizi kullanın. \/ Use your saved information ",
            "paragraph": "Ödeme anında kayıtlı bilgilerinizi kullanmak için  {{ phone }} telefonunuza gelen doğrulama kodunu girin. \/ To check out with your saved details, enter the verification code sent to {{ phone }}. ",
            "paragraph_aria": "Ödeme anında kayıtlı bilgilerinizi kullanmak için telefonunuza gelen doğrulama kodunu girin. {{ phone }}  \/ To check out with your saved details, enter the verification code sent to the mobile number ending with: {{ phone }}. "
          },
          "accelerated": {
            "title": "Doğrulama Kodunuzu girin \/ Enter your verification code ",
            "paragraph": "Ödemenizi tamamlamak için {{ phone }} telefonunuza gelen kodu giriniz. \/ To complete your purchase, enter the code sent to {{ phone }}. "
          },
          "verification_code_label": "Doğrulama Kodu \/ Verification code ",
          "fill_manually": "Kapat \/ Close ",
          "code_sending": "Kod Gönderiliyor... \/ Sending code... ",
          "code_sent": "Kod Gönderildi \/ Code sent "
        },
        "authorize_purchase": "Ödemeyi Onayla \/ Authorize purchase ",
        "description_html": "Bir sonraki sefer Shopify tarafından geliştirilmiş güvenli ödeme yöntemleri için SMS kodu alacaksınız. \/ Next time you check out here or on other stores powered by Shopify, you'll receive a code by SMS to securely purchase with Shopify Pay. ",
        "terms_and_privacy_html": "By continuing, you agree to Shopify Pay’s <a class=\"link--muted\" data-modal data-remember-policy-link=\"privacy_policy\" title=\"Shopify Pay Privacy Policy\" href=\"{{ privacy_href }}\">Privacy Policy<\/a> and <a class=\"link--muted\" data-modal data-remember-policy-link=\"terms\" title=\"Shopify Pay Terms of Service\" href=\"{{ terms_href }}\">Terms of Service<\/a>. "
      },
      "thank_you": {
        "fulfillment": {
          "quantity_label": "Miktar \/ Quantity ",
          "description_label": "Açıklama \/ Description ",
          "product_image_label": "Ürün resmi \/ Product image ",
          "unfulfilled_table_title": "Ürünler kargolama için hazırlanıyor \/ Items preparing for shipment ",
          "fulfilled_table_title": "Kargolanacak ürünler \/ Items in this shipmen"
        },
        "marker": {
          "shipping": "Kargo adresi \/ Shipping address ",
          "current": "Şuanki kargolama adresi \/ Current shipment location "
        },
        "login_reorder_link_text": {
          "other": "Bu ürünleride alın \/ buy these products too ",
          "one": "Bu ürünleride alın \/ buy this product too "
        },
        "track_shipment": "Kargo takip \/ Track shipment ",
        "order_updates_submit_subscription": "Onayla \/ Submit ",
        "order_updates_subscribe_to_phone_notifications": "Kargo güncellemelerini SMS ile al \/ Get shipping updates by SMS ",
        "order_updates_subscribe_to_email_or_phone_notifications": "Kargo güncellemelerini SMS veya e-posta ile al \/ Get shipping updates by email or SMS ",
        "order_updates_subscribe_to_email_notifications": "Kargo güncellemelerini e-posta ile al \/ Get shipping updates by email ",
        "login": "Giriş yap \/ Log in ",
        "customer_validation_error_phone": "Geçersiz telefon yada sipariş numarası \/ Invalid phone or order number. ",
        "customer_validation_error": "Geçersiz e-posta yada sipariş numarası \/ Invalid email or order number. ",
        "order_number_label": "Sipariş Numarası \/ Order number ",
        "cancelled_title": "Siparişiniz iptal edilmiştir \/ Your order has been canceled ",
        "contact_us": "Bizimle iletişime geçin \/ Contact us ",
        "contact_us_lowercase": "bizimle iletişime geçin \/ contact us ",
        "contact_us_html": "Yardımamı ihtiyacınız var? {{ contact_us }}  \/ Need help? {{ contact_us }} ",
        "updated_time": "{{ time_ago }} önce güncellendi  \/ Updated {{ time_ago }} ago ",
        "failure": "Ulaşmadı \/ Not delivered ",
        "failed_title": "Kargolamanız ulaşmadı \/ Your shipment couldn't be delivered ",
        "delivered": "Ulaştı. \/ Delivered ",
        "delivered_title": "Kargonuz ulaşmıştır. \/ Your shipment has been delivered ",
        "out_for_delivery": "Dağıtım için dışarıda \/ Out for delivery ",
        "no_tracking_number": "Bu kargo için takip numarası mevcut değildir. \/ There is no tracking number for this shipment. ",
        "in_transit": "Yolda \/ On its way ",
        "order_updates_title": "Sipariş Güncellemeleri \/ Order updates ",
        "confirmed_title": "Kargonuz onaylanmıştır. \/ Your shipment is confirmed ",
        "thank_you_title": "Siparişiniz Doğrulanmıştır. \/ Your order is confirmed ",
        "confirmed": "Doğrulandı. \/ Confirmed ",
        "re-order": "Aynı ürünleri tekrar sipariş ver \/ Re-order the same items ",
        "estimated_arrival": "Tahmini ulaşım tarihi: \/ Estimated delivery date: ",
        "company_tracking_number": "{{ company }} takip numarası :   \/ {{ company }} tracking number: ",
        "tracking_number": "Takip numarası :   \/ Tracking number: ",
        "shipping_method_title": "Kargo Yöntemi \/ Shipping method ",
        "payment_method_title": "Ödeme yöntemi \/ Payment method ",
        "billing_address_title": "Fatura adresi \/ Billing address ",
        "shipping_address_title": "Kargolama adresi \/ Shipping address ",
        "customer_information_title": "Müşteri Bilgileri \/ Customer information ",
        "cancelled_page_title": "Sipariş  iptal edildi \/ Order canceled ",
        "page_title_no_name": "Teşekkürler! \/ Thank you! ",
        "page_title": "Teşekkür ederiz {{ first_name }}!  \/ Thank you {{ first_name }}! ",
        "shipping_information_title": "Kargo Bilgileri \/ Shipping information ",
        "payment_information_title": "Ödeme Bilgileri \/ Payment information ",
        "print_link_label": "Fatura yazdır \/ Print receipt ",
        "return_to_store_link_label": "Alışverişe devam et \/ Continue shopping ",
        "confirmation_email_sent_text": "Doğrulama maili {{ email }} adresinize gönderilmiştir. \/ A confirmation email has been sent to {{ email }} ",
        "title": "Ödemeniz için teşekkür ederiz! \/ Thank you for your purchase! ",
        "thank_you_description": "Siparişiniz onaylanmıştır. Siparişinizi en kısa sürede hazırlayacağız. Sipariş bilgi ve güncellemeleri için sayfaya geri geliniz. \/ We've accepted your order, and we're getting it ready. Come back to this page for updates on your order status. ",
        "confirmed_description": "Siparişiniz onaylanmıştır. Siparişinizi en kısa sürede hazırlayacağız. Sipariş kargo ve güncellemeleri için sayfaya geri geliniz. \/We've accepted your order, and we're getting it ready. Come back to this page for updates on your shipment status.  ",
        "order_updates_description_html": "Güncellemeler {{ customer_contact }} adresine gönderilecektir.  \/ Updates will be sent to {{ customer_contact }} ",
        "order_updates_current_step_prefix": "Suanki Aşama: \/ Current step: ",
        "order_updates_past_step_prefix": "Önceki Aşama: \/ Past step: ",
        "order_updates_upcoming_step_prefix": "Sıradaki Aşama: \/ Upcoming step: ",
        "in_transit_title": "Kargonuz yoldadır. \/ Your shipment is on the way ",
        "in_transit_description": "Sipariş kargo ve güncellemeleri için sayfaya geri geliniz. \/ Come back to this page for updates on your shipment status. ",
        "in_transit_description_days": "Paketinizi tahminen {{ number }} gün içinde almış olacaksınız \/ You should receive your package in the next {{ number }} days. ",
        "in_transit_description_today": "Paketinizi gün içinde almış olacaksınız.  \/ You should receive your package today. ",
        "in_transit_description_tomorrow": "Paketinizi yarın almış olacaksınız.  \/ You should receive your package in the next day. ",
        "out_for_delivery_title": "Kargonuz dağıtımdadır. \/ Your shipment is out for delivery ",
        "out_for_delivery_description_html": "Kargonuz dağıtım aracındadır – tahmini gün içinde elinizde olacaktır. Eğer 2 gün içerisinde hala size ulaşmamış olur ise  Lütfen {{ contact_us }}.  \/ Your shipment is on the delivery truck – expect it to arrive today. If you still haven't received it in the next 2 days, please {{ contact_us }}. ",
        "attempted_delivery": "Dağıtım denendi. \/ Attempted delivery ",
        "attempted_delivery_title": "Kargo Dağıtım denendi. \/ An attempt was made to deliver your shipment ",
        "attempted_delivery_description_html": "Kargo dağıtımı denendi fakat başarılı olmadı. Lütfen yeni bir dağıtım için {{ contact_us }} \/ An attempt was made to deliver your shipment but it was unsuccessful. Please {{ contact_us }} to arrange another delivery attempt. ",
        "delivered_description_html": "Kargonuz belirtmiş olduğunuz adrese teslim edildi. Almadı iseniz veya farklı bir problem yaşadıysanız lütfen  {{ contact_us }}.  \/ Your shipment has been delivered to the address you provided. If you haven't received it, or if you have any other problems, please {{ contact_us }}. ",
        "failed_contact_merchant": "{{ company }} bilgilerine göre siparişiniz planlandığı şekilde gönderilememiştir. Lütfen {{ company }} ile yeni bir gönderi için iletişime geçiniz. \/ According to {{ company }}, your order couldn't be delivered as planned. Please contact {{ company }} to arrange another delivery attempt. ",
        "failed_contact_merchant_no_company": "Siparişiniz planladığı şekilde gönderilememiştir. Lütfen yeni bir gönderi planlamak için bizimle iletişime geçiniz. \/ Your order couldn't be delivered as planned. Please contact us to arrange another delivery attempt. ",
        "non_shippable_title": "Siparişiniz tamamlanmıştır. \/ Your order is complete ",
        "login_title": "Kargo detayları için sisteme giriş yapınız. \/ Log in to view all shipment details ",
        "login_description": "Fatura sipariş numarasını göndermiş olduğumuz e-posta içinde bulabilirsiniz.  \/ You can find your order number in the receipt you received via email. ",
        "login_description_phone": "Fatura sipariş numarasını göndermiş olduğumuz SMS mesajında bulabilirsiniz.  \/ You can find your order number in the receipt you received via sms. ",
        "login_not_customer_html": "{{ name }} değilmisiniz? {{ link }} tıklayınız.  \/ Not {{ name }}? You can {{ link }} ",
        "customer_information_hidden_fields_message": "Bütün müşteri bilgileri için giriş yapınız. \/ Log in to view all customer information. ",
        "cancelled_description": "Siparişiniz bu {{ date }} tarihte iptal edilmiştir. Lütfen sorularınız için iletişime geçiniz.  \/ Your order was canceled on {{ date }}. Please contact us if you have any questions. ",
        "unfulfilled_items_title": "Kargolama için hazırlanıyor. \/ Preparing for shipment ",
        "unfulfilled_items_description": "Şuan ürünleri kargolama için hazırlıyoruz. \/ We are currently preparing these items for shipment. ",
        "opt_in_message_html": "Bilgileriniz sorunsuz bir şekilde kaydedilmiştir.<span class=\"emphasis\">Shopify Pay<\/span>.  \/ Your information was successfully saved with <span class=\"emphasis\">Shopify Pay<\/span>. ",
        "order_updates_description_missing": "Herhangi bir kargo güncellemesi almadınız. \/ You are not receiving shipping updates. ",
        "order_updates_description_email_html": "Kısa bir süre sonra sipariş numaranızı içeren bir e-posta alacaksınız. Tüm güncellemeler {{ customer_contact }}  gönderilecektir. \/ You will receive a confirmation email with your order number shortly. All updates will be sent to {{ customer_contact }} ",
        "order_updates_description_phone_html": "Kısa bir süre sonra sipariş numaranızı içeren bir SMS alacaksınız. Tüm güncellemeler {{ customer_contact }} gönderilecektir. \/ You will receive a confirmation SMS with your order number shortly. All updates will be sent to {{ customer_contact }} ",
        "order_updates_description_email_and_phone_html": "Güncellemeler {{ email }} ve {{ phone }} bilgilerinize gönderilecektir.  \/ Updates will be sent to {{ email }} and {{ phone }}. ",
        "shopify_pay": {
          "learn_more_label": "Shopify Pay ile ilgili daha fazla bilgi öğren \/ Learn more about Shopify Pay "
        },
        "shipping_address_map_title": "Google Map Kargo adresi olarak bu kısmı pinlemiştir: {{ address }}  \/ Google map displaying pin point of shipping address: {{ address }} "
      },
      "payment_gateway": {
        "credit_card_label": "Kredi Kartı \/ Credit card ",
        "bank_deposit_label": "Banka Havale\/ EFT \/ Bank Deposit ",
        "money_order_label": "Para Transferi \/ Money Order ",
        "cash_on_delivery_label": "Cash on Delivery (COD)  \/ Cash on Delivery (COD) "
      },
      "processing": {
        "wait": {
          "short": "Siparişleriniz işleme alınmıştır. \/ Your order's being processed. ",
          "long": "Siparişiniz işleme alındığında e-posta ile bilgilendirileceksiniz. Şuan yüksek miktarda sipariş bulunmaktadır. \/ You'll receive an email as soon as your order's processed. There's currently a high volume of orders. ",
          "no_auto_refresh_html": "Eğer otomatik olarak yönlendirilmezseniz, {{ link }}.  \/ If you're not automatically redirected, {{ link }}. ",
          "refresh_this_page": "Sayfayı yenile \/ refresh this page ",
          "medium": {
            "one": "Siparişiniz hazırlanıyor tahmini bekleme süresi 1 dakikadır. \/ Your order's being processed. Estimated wait time is 1 minute. ",
            "other": "Siparişiniz hazırlanıyor tahmini bekleme süresi {{ count }} dakikadır. \/ Your order's being processed. Estimated wait time is {{ count }} minutes. "
          }
        },
        "title": "Siparişiniz işleniyor. \/ Processing order ",
        "page_title": "Sipariş işleniyor. \/ Processing order ",
        "continue_to_payment_gateway_button_label_error": "Ödeme sayfasına geri dön \/ Return to payment gateway ",
        "complete_your_purchase_title_error": "Ödeme yöntemini doğrulayınız \/ Correct your payment information ",
        "continue_to_payment_gateway_button_label": "Ödeme sayfasına devam ediniz \/ Continue to the payment gateway ",
        "continue_to_payment_gateway_notice": "Ödeme sayfasına devam ediniz ve ödeme bilgilerini giriniz \/ Continue to the payment gateway to add your payment information. ",
        "complete_your_purchase_title": "Ödemenizi tamamlayınız \/ Complete your purchase ",
        "redirecting_notice": "Sizi yönlendirirken bekleyiniz. \/ Please wait while we redirect you. ",
        "redirecting_title": "Yönlendiriliyor... \/ Redirecting… ",
        "redirecting_page_title": "Yönlendiriliyor... \/ Redirecting… ",
        "continue_to_payment_gateway_notice_error": "Ödeme bilgilerinizde hatalar mevcuttur. Ödeme alanına dönüp düzeltiniz. \/ Your payment information contains errors. Return to the payment gateway to correct them. "
      },
      "apple_pay": {
        "button_html": "Bununla al {{ logo }}  \/ Buy with {{ logo }} "
      },
      "paypal": {
        "button_html": "Bununla öde {{ logo }}  \/ Checkout with {{ logo }} "
      },
      "alternative_payment_method_banner": {
        "or": "VEYA \/ OR"
      },
      "payment_errors": {
        "generic_error": "Ödeme işleminiz sırasında hata oluştu. Tekrar deneyiniz. \/ There was an error processing your payment. Please try again. ",
        "rejected_transaction": "Ödeme yöntemi sağlayıcınız işlemi ret etti. Tekrar deneyiniz. \/ The payment provider rejected the transaction. Please try again. ",
        "credit_card_processing": "Kredi kartınız ile işlem yaparken teknik problemler yaşıyoruz. Lütfen kısa bir süre sonra tekrar deneyiniz. \/ We are experiencing technical difficulties while trying to process your credit card. Please try again in a few minutes. ",
        "order_total_changed": "Sipariş toplamınız değişmiştir. Lütfen siparişinizi tamamlamadan önce değişikliklerden kaçınınız. \/ The total of your order has changed. Please make sure you're aware of the changes before completing your order. ",
        "payment_processing": "Ödeme servisi ile problem mevcuttur. Lütfen farklı bir ödeme yöntemi seçiniz yada tekrar deneyiniz. \/ There was a problem with the payment service. Please select a different payment method or try again later. ",
        "paypal_zero_amount": "Bu {{ amount }} miktar siparişlerinizde paypal kullanamazsınız. Siparişinizi düzenleyip ödemeye geçebilirsiniz.  \/ You can't use PayPal for {{ amount }} orders. Confirm your order is correct and continue with Checkout. "
      },
      "shipping_errors": {
        "shipping_method": "Sepetiniz güncellenmiş ve önceki kargo ücreti değişmiştir. Lütfen yeni ücreti seçiniz. \/ Your cart has been modified and the shipping rate you previously selected no longer applies. Please select a new rate. "
      },
      "alternative_payment_method": {
        "button_html": "Bununla öde: {{ method }}  \/ Checkout with: {{ method }} "
      },
      "notifications": {
        "title": "Uyarılar \/ Notifications "
      }
    },
    "feed": {
      "more": "Fazlası \/ More "
    },
    "attributes": {
      "email": "eposta \/ email ",
      "password": "şifre \/ password ",
      "password_confirmation": "Şifre doğrulaması \/ The password confirmation ",
      "first_name": "Adınız \/ first name ",
      "last_name": "Soyadı \/ last name ",
      "body": "Vücut \/ body "
    },
    "addresses": {
      "zip_code": "Alan Kodu \/ Zip code ",
      "postal_code": "Posta Kodu \/ Postal code",
      "postcode": "Posta Kodu \/ Postcode ",
      "pincode": "Pin Kodu \/ Pincode",
      "region": "Bölge \/ Region ",
      "state": "Ülke \/ State",
      "state_and_territory": "Ülke\/Alan \/ State\/territory ",
      "county": "İlçe \/ County ",
      "province": "Mahalle \/ Province ",
      "prefecture": "Belde \/ Prefecture ",
      "confirm": "Bu adresi silmek istediğinize eminmisiniz? \/ Are you sure you wish to delete this address? "
    },
    "errors": {
      "blank": "Boş bırakılamaz \/ can't be blank ",
      "credit_card_session_expired": "Kredi kartı izin süresi geçmiştir, lütfen ödeme bilgilerini yeniden giriniz. Kartınızdan ödeme alınmamıştır. \/ Credit card authorization has expired, please enter your payment information again. Your card has not been charged. ",
      "empty": "Boş bırakılamaz \/ can't be empty ",
      "invalid_email": "Geçerli bir e-posta adresi olmalıdır \/ must be a valid email address ",
      "discount_disabled": "Bu indirim geçerliliğini yitirmiştir. \/ This discount has been disabled ",
      "discount_expired": "Bu indirim uzun süredir geçersizdir. \/ This discount is not valid anymore ",
      "discount_limit_reached": "Bu indirim kullanım limit sayısını aşmıştır. \/ This discount has reached its usage limit ",
      "discount_not_found": "Girdiğiniz kod ile uyumlu indirim kodu bulunamamıştır \/ Unable to find a valid discount matching the code entered ",
      "customer_already_used_once_per_customer_discount_notice": "Bu indirim kullanım limit sayısını aşmıştır. \/ This discount has reached its usage limit ",
      "gift_card_already_applied": "Kod ödeme işleminize uygulanmıştır. \/ Code has already been applied to your checkout ",
      "gift_card_code_invalid": "Geçersiz kod \/ Code is invalid ",
      "gift_card_currency_mismatch": "{{ gift_card_currency }} hediye kartı uygulanamaz {{ checkout_currency }} siparişlerinize  \/ {{ gift_card_currency }} gift cards can't be applied on {{ checkout_currency }} orders ",
      "gift_card_depleted": "Hediye kartınızda bakiye bulunamamıştır. \/ There are no funds left on this gift card ",
      "gift_card_disabled": "Hediye kartınız geçersizdir. \/ Gift card is disabled ",
      "gift_card_expired": "Hediye kartınızın kullanım süresi dolmuştur. \/ Gift card is expired ",
      "invalid": "geçersiz \/ is invalid ",
      "taken": "önceden alınmıştır \/ has already been taken ",
      "contains_html_tags": "HTML tagları içermiyor \/ cannot contain HTML tags ",
      "too_short": "çok kısa (en az {{ count }} karakter)  \/ is too short (minimum is {{ count }} characters) ",
      "too_long": "çok uzun (en fazla {{ count }} karakter)  \/ is too long (maximum is {{ count }} characters) ",
      "password_mismatch": "Geçerli parola ile uyuşmalıdır.  \/ must match the provided password. ",
      "contains_spaces": "boşluk ile başlar yada biter \/ starts or ends with spaces. ",
      "email_domain_invalid": "Sağlacıyı geçersizdir \/ provider is not supported",
      "invalid_for_country": "Bu {{ country }} de geçersizdir.  \/ is not valid for {{ country }} ",
      "invalid_for_country_and_province": "Bu {{ province }} ve {{ country }} de geçersizdir. \/ is not valid for {{ province }} and {{ country }} ",
      "invalid_province_in_country": "Bu bölgede {{ country }} geçersizdir \/ is not a valid province in {{ country }} ",
      "invalid_state_in_country": "Bu eyalette {{ country }} geçersizdir \/ is not a valid state in {{ country }} ",
      "invalid_region_in_country": "Bu alanın {{ country }} de geçersizdir. \/ is not a valid region in {{ country }}",
      "less_than_or_equal_to": "küçük yada eşit olmalı {{ count }}  \/ must be less than or equal to {{ count }}",
      "not_supported": "Desteklenmiyor \/ is not supported ",
      "full_name_required": "Lütfen geçerli bir isim giriniz \/ Please enter a valid name.",
      "invalid_for_card_type": "Geçerli değil \/ is not valid ",
      "invalid_type": "Özür dileriz bu tip kartları kabul edemiyoruz \/ sorry, we do not accept cards of this type ",
      "invalid_format": "Format geçerli değildir \/ format is not valid ",
      "expired": "Süresi geçmiş \/ has expired ",
      "invalid_start_date_or_issue_number_for_debit": "Geçerli bir başlangıç tarihi yada numara gereklidir \/ a valid start date or issue number is required",
      "invalid_expiry_year": "Geçerli bir son kullanım tarihi değildir. \/ is not a valid expiration year ",
      "reset_password_html": "Bu email adresi başka bir hesap ile ilişkilidir. Eğer bu hesap size ait ise , bunu deneyebilirsiniz <a href=\"\/account\/login#recover\">Şifremi resetle<\/a>    \/ This email address is already associated with an account. If this account is yours, you can <a href=\"\/account\/login#recover\">reset your password<\/a> ",
      "verify_email": "Adresinize email gönderdik {{ customer_email }}, Lütfen doğrulamak için e-postanızdaki linke tıklayınız. \/ We have sent an email to {{ customer_email }}, please click the link included to verify your email address. "
    }
  }
}